import { render, staticRenderFns } from "./GovUses.vue?vue&type=template&id=1a867c48"
import script from "./GovUses.vue?vue&type=script&lang=js"
export * from "./GovUses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports